import MigratortronBaseService from './MigratortronBaseService';
import { GetResponse, MigrateRequest } from '~/models/Operations';
import mapErrorToObject from '~/transformations/mapAppErrorToObject';

class RolesMigrationService extends MigratortronBaseService {
  constructor(payload: MigrateRequest, preview: boolean) {
    super(payload, preview);
  }

  get raw() {
    return this.sourceRepo.roles.roles;
  }

  // Expose sourceRepo methods for convenience
  CreateRole = this.sourceRepo.roles.CreateRole;
  RemoveRole = this.sourceRepo.roles.RemoveRole;
  UpdateRole = this.sourceRepo.roles.UpdateRole;

  /**
   * Gets a list of roles from the Managemet API
   * @returns list of Role
   */
  GetRoles = async () => {
    await this.sourceRepo.roles.GetRoles();

    for (const [projectId, targetRepo] of Object.entries(this.targetRepos)) {
      await targetRepo.roles.GetRoles();
    }

    return this.sourceRepo.roles.roles;
  };

  MapGetRolesResponse = () => {
    const { sourceRepo, targetRepos } = this;
    const response: { [alias: string]: GetResponse } = {};
    response[sourceRepo.alias] = {
      [sourceRepo.projectId]: {
        roles: sourceRepo.roles.roles,
        error: mapErrorToObject(sourceRepo.roles.error),
      },
    };
    for (const [projectId, targetRepo] of Object.entries(targetRepos)) {
      response[targetRepo?.alias || ''] = {
        [projectId]: {
          roles: targetRepo?.roles.roles,
          error: mapErrorToObject(targetRepo?.roles.error),
        },
      };
    }
    return response;
  };
}

export default RolesMigrationService;
